export default function TeacherHome() {
  return <div>Welcome Teacher!</div>;
}
